import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';

import { toggleStatsModal, selectOffice, getOfficesDD, getStats, } from './actions';
import StatsView from './StatsView';


class StatsContainer extends Component {
  constructor(props) {
    super(props);

    this.handleToggle = this.handleToggle.bind(this);
    this.handleSelectOffice = this.handleSelectOffice.bind(this);
  }

  handleToggle() {
    const { toggleStatsModal, } = this.props;

    toggleStatsModal();
  }

  handleSelectOffice(selected) {
    const { selectOffice, getStats, } = this.props;
    if (selected !== null) {
      getStats(selected.id);
    }

    selectOffice(selected);
  }
  
  render() {
    const { 
      modalData, statsData, officesDDData,
      getOfficesDD, getStats,
    } = this.props;

    return (
      <Modal 
        showCloseIcon={true} 
        open={modalData.isOpen} 
        onClose={this.handleToggle} 
        animationDuration={0}
        center
        styles={{
          modal: {
            width: 'calc(95vw - 28px)',
            background: 'none',
            boxShadow: 'none',
            padding: 0,
            borderRadius: 0,
            top: 20,
            maxWidth: 1200,
            marginLeft: 'auto',
            marginRight: 'auto',
            marginTop: 'unset',
            marginBottom: 'unset',
          },
          overlay: {
            display: 'block',
            padding: 0, 
            position: 'absolute',
            height: '100vh',
          }
        }}
      >
        { modalData.isOpen &&
          <StatsView
            modalData={modalData}
            officesDDData={officesDDData}
            statsData={statsData}
            handleSelectOffice={this.handleSelectOffice}
            getOfficesDD={getOfficesDD}
            getStats={getStats}
          />
        }
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  const { stats, } = state;
  return { 
    officesDDData: stats.officesDDData,
    statsData: stats.statsData,
    modalData: stats.modalData,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleStatsModal: bindActionCreators(toggleStatsModal, dispatch),
    selectOffice: bindActionCreators(selectOffice, dispatch),
    getOfficesDD: bindActionCreators(getOfficesDD, dispatch),
    getStats: bindActionCreators(getStats, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StatsContainer);


// WEBPACK FOOTER //
// ./src/components/Stats/StatsContainer.js